/** Require a deliberate pause, including when crossing adjacent equipment. */
export const EQUIPMENT_HOVER_DELAY_MS = 500;
export function createHoverIntent<T>(show: (value: T) => void) {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let anchor: {x: number; y: number} | undefined;
  function cancel() { clearTimeout(timer); timer = undefined; anchor = undefined; }
  function schedule(value: T, point: {x: number; y: number}) {
    cancel(); anchor = point;
    timer = setTimeout(() => { timer = undefined; anchor = undefined; show(value); }, EQUIPMENT_HOVER_DELAY_MS);
  }
  return {
    cancel, schedule,
    move(value: T, point: {x: number; y: number}) {
      if (anchor && Math.hypot(point.x - anchor.x, point.y - anchor.y) >= 4) schedule(value, point);
    },
  };
}
